import React from "react";
import { useTaxSelector } from "../redux/general/reduxStore";
import { useTranslation } from "react-i18next";
import Alert from "@mui/material/Alert";
import { OverridableStringUnion } from "@mui/types";
import { AlertColor, AlertPropsColorOverrides } from "@mui/material";

export const TaxGuruProfileIndicator = () => {
    const { actuatorInfo } = useTaxSelector((state) => state.taxApp);
    const { t } = useTranslation();

    if (!actuatorInfo || actuatorInfo.app.profile === "prod") {
        return null;
    }

    const { profile } = actuatorInfo.app;
    let color: OverridableStringUnion<AlertColor, AlertPropsColorOverrides> = "info";
    switch (profile) {
        case "local":
        case "dev":
            color = "error";
            break;
        case "test":
        case "learning":
            color = "warning";
            break;
    }
    const profileName = t("aboutApp.profile." + profile);

    return (
        <Alert icon={false} color={color}>
            {profileName}
        </Alert>
    );
};

export default TaxGuruProfileIndicator;
